import { render, staticRenderFns } from "./CandidateTile.vue?vue&type=template&id=1fe82a8e&scoped=true&"
import script from "./CandidateTile.vue?vue&type=script&lang=js&"
export * from "./CandidateTile.vue?vue&type=script&lang=js&"
import style0 from "./CandidateTile.vue?vue&type=style&index=0&id=1fe82a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe82a8e",
  null
  
)

export default component.exports